<div class="container" aria-modal="true">
    <div mat-dialog-title class="dialog-title">
        <h1 mat-dialog-title>Manipulate Report</h1>
        <button mat-icon-button aria-label="close dialog" mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-dialog-content>
        <form id="filter_form" class="filter_form" [formGroup]="userForm">
            <div class="subtitle"><span class="red">*</span>Indicates required field</div>
            <div class="title">REPORT DETAILS</div>
            <mat-form-field appearance="outline">
                <mat-label>Report ID</mat-label>
                <input matInput formControlName="report_id" (focusout)="checkIfReportExists()" required cdkFocusInitial>
                <mat-error>Required Field</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Authorization Status</mat-label>
                <mat-select formControlName="authorization_status_id">
                    <mat-option [value]="null">--</mat-option>
                    @for (status of authorizationStatusList; track status; let i = $index) {
                    <mat-option [value]="i">{{status}}</mat-option>
                    }
                </mat-select>
                <mat-error>Required Field</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Report Status</mat-label>
                <mat-select formControlName="report_status_id" required>
                    @for (status of reportStatusList; track status; let i = $index) {
                    <mat-option [value]="i">{{status}}</mat-option>
                    }
                </mat-select>
                <mat-error>Required Field</mat-error>
            </mat-form-field>
            <div style="flex: 40%">

            </div>
            @for (page of pageNumber; track page; let j = $index) {
                <mat-form-field appearance="outline">
                <mat-label>Page {{ j + 1 }} Status</mat-label>
                <mat-select [formControlName]="page" required>
                    @for (status of pageStatusList; track status; let i = $index) {
                    <mat-option [value]="i">{{status}}</mat-option>
                    }
                </mat-select>
                <mat-error>Required Field</mat-error>
                </mat-form-field>
            }
        </form>
    </mat-dialog-content>
    <div mat-dialog-actions>
        <div class="button-row">
            <button class="usa-button usa-button--secondary" mat-dialog-close>Cancel</button>
            <button class="usa-button" style="max-width: 300px" [disabled]="!report" (click)="deleteAllSignatures()">Delete Signatures ({{report?.signatures?.length ?? "0"}})</button>
            <button class="usa-button" [disabled]="!userForm.valid" (click)="saveReport()">Update</button>
        </div>
    </div>
</div>